import React, { useState, useEffect } from "react";
import { API_URL } from '../../../config';
function Conversations() {
    const [count, setCount] = useState(null); // État pour stocker le nombre de conversations
    const [, setLoading] = useState(true); // État pour gérer le chargement
    const [, setError] = useState(null); // État pour gérer les erreurs

    useEffect(() => {
        // Fonction pour récupérer le nombre de conversations
        const fetchConversationCount = async () => {
          try {
            setLoading(true); // Active l'indicateur de chargement
            const token = localStorage.getItem("token"); // Récupère le token depuis le localStorage
    
            const response = await fetch(`${API_URL}/api/message/getconversationcount`, {
              method: "GET",
              headers: {
                Authorization: `Bearer ${token}`, // Ajoute le token au header Authorization
                "Content-Type": "application/json",
              },
            });
    
            if (!response.ok) {
              // Vérifie si la réponse HTTP est correcte
              throw new Error(`Erreur : ${response.status} ${response.statusText}`);
            }
    
            const data = await response.json(); // Convertit la réponse en JSON
    
            if (data.status === 0) {
              setCount(data.count); // Met à jour l'état avec le nombre de conversations
            } else {
              throw new Error(data.message || "Erreur lors de la récupération des données");
            }
          } catch (err) {
            setError(err.message); // Met à jour l'état des erreurs
          } finally {
            setLoading(false); // Désactive l'indicateur de chargement
          }
        };
    
        fetchConversationCount();
      }, []);

  return (
    <div className="col-md-6 col-xl-3 mb-4">
        <div className="card shadow border-start-warning py-2">
            <div className="card-body">
                <div className="row align-items-center no-gutters">
                    <div className="col me-2">
                        <div className="text-uppercase text-warning fw-bold text-xs mb-1"><span>Conversations</span></div>
                        <div className="text-dark fw-bold h5 mb-0"><span>{count?count:0}</span></div>
                    </div>
                    <div className="col-auto"><i className="fas fa-comments fa-2x text-gray-300"></i></div>
                </div>
            </div>
        </div>
    </div>
  )
}

export default Conversations